import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { CreatePackageTimer, PackageTimer, PackageTimerListResponse, PackageTimerQueryParams, UpdatePackageTimer } from '@frontend/package/types';

export class PackageTimerClient extends APIClient {
    public static readonly endpoint = '/package-api/v1';

    public static async fetchAccountPackageTimers(
        accountId: string,
        transactionId: string,
        packageId: string,
        queryParams?: ApiQueryParams<PackageTimerQueryParams>
    ): Promise<PackageTimerListResponse> {
        return await this.apiPaginated<PackageTimerListResponse, PackageTimerQueryParams>(
            `${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/packages/${packageId}/timers`,
            queryParams
        );
    }

    public static async fetchAccountPackageTimer(accountId: string, transactionId: string, packageId: string, timerId: string): Promise<PackageTimer> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/packages/${packageId}/timers/${timerId}`);
        return await this.handleResponse<PackageTimer>(response);
    }

    public static async postAccountPackageTimer(accountId: string, transactionId: string, packageId: string, body: CreatePackageTimer): Promise<PackageTimer> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/packages/${packageId}/timers`, body);
        return await this.handleResponse<PackageTimer>(response);
    }

    public static async patchAccountPackageTimer(
        accountId: string,
        transactionId: string,
        packageId: string,
        timerId: string,
        body: UpdatePackageTimer
    ): Promise<PackageTimer> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/packages/${packageId}/timers/${timerId}`, body);
        return await this.handleResponse<PackageTimer>(response);
    }

    public static async deleteAccountPackageTimer(accountId: string, transactionId: string, packageId: string, timerId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/packages/${packageId}/timers/${timerId}`);
        await this.handleVoidResponse(response);
    }
}
